module.exports = __webpack_public_path__ + "static/media/oldBrowserBG.ba275275.png";